<template>
  <button class="button is-danger" @click="$emit('click')">
    <span class="icon">
      <i class="fa fa-trash"></i>
    </span>
    <span v-if="label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  name: 'DeleteButton',
  props: {
    label: String
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/forms/DeleteButton.vue